
import { Icon } from '@iconify/react';
import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Button, ButtonBase, Card, CardActionArea, Grid, IconButton, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import {  useTranslation } from 'react-i18next';

const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(0, 0),
    color: theme.palette.primary.darker,
    backgroundColor: theme.palette.primary.lighter
  }));
  
  const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
      theme.palette.primary.dark,
      0.24
    )} 100%)`
  }));

export const fancyCardSize = {
  xs:6, sm:6, md:2.4, lg:2, xl:1.714
};

export function FancyCard(props){
  const {t} = useTranslation();
    return <RootStyle className={ "fancyCard " + (props.selected ? "selected" : "notSelected") } >
      
        <CardActionArea   onClick={ (ev) => { props.cardClicked(props.metric.Name); } } sx={{p:5}}>
        {/* <IconWrapperStyle>
            <Icon icon={androidFilled} width={24} height={24} />
        </IconWrapperStyle> */}
        <Typography variant="h3">{fShortenNumber(props.metric.Value)}</Typography>
        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
            {t(props.metric.Name)}
        </Typography>
        </CardActionArea>
    </RootStyle>;
}

